<div class="flex-wrapper mint-snackbar-wrapper wrapper-{{ data.class }}" matTooltip="Click to Dismiss" (click)="dismissMessage()">
  @if (data.class === 'stealth') {
    <img data-notify="icon" width="150px" class="img-circle pull-left" src="/uploads/system_images/yeehro-x-icon.png">
  }

  @if (data.title) {
    <div class="title">
      {{ data.title }}
    </div>
  }

  <div class="main-message-content {{ data.class }}">
    {{ data.message }}
  </div>

  @if (data.class !== 'stealth') {
    <div class="message-icon">
      <img src="/uploads/system_images/yeehro-x-icon.png" height="50px" />
    </div>
  }

  <!--   <div class="close-icon default-flex">
  <span class="material-icons">clear</span>
</div> -->
</div>